import { ADMIN_MODAL_TYPE } from '@data/modalTypes'
import { useBedRequest } from '@hook'
import { PencilIcon } from '@icons'
import { useModalStore } from '@modal'
import { BedRequestMock } from '@type/bedRequest.type'
import { Badge, Button, SideDrawer } from '@ui'
import InformationList from '@ui/InformationList'
import { Box, Spinner, Text } from 'grommet'
import moment from 'moment'
import { useMemo } from 'react'

type Props = {
  onClose: () => void
  defaultData?: BedRequestMock
}

export const BedDetails = ({ onClose, defaultData }: Props) => {
  const { openModal } = useModalStore()
  const { singleBedRequest, singleReqLoading } = useBedRequest({ bedId: defaultData?.id })
  const singleData = useMemo(() => {
    return singleBedRequest?.data
  }, [singleBedRequest])
  const included = useMemo(() => {
    return singleBedRequest?.included
  }, [singleBedRequest])

  const details = useMemo(() => {
    if (singleData) {
      const unitId = included?.find(
        ({ type, id }) => type === 'admission_order' && id === singleData.relationships.admission_order.data?.id
      )?.relationships?.created_by.data?.id
      return {
        'Assigned by': singleData?.attributes.bed_id
          ? included?.find(({ type, id }) => type === 'staff' && id === singleData.relationships.assigned_by.data?.id)
              ?.attributes.first_name +
            ' ' +
            included?.find(({ type, id }) => type === 'staff' && id === singleData.relationships.assigned_by.data?.id)
              ?.attributes.last_name
          : '---',
        'Bed type': included?.find(({ type }) => type === 'bed')?.attributes.bed_type || '---',
        Date: moment(singleData?.attributes.updated_at).format('DD/MM/YYYY'),
        Feature: included?.find(({ type }) => type === 'admission_order')?.attributes.telemetry
          ? 'Telemetry'
          : 'Non-telemetry',
        Patient: included?.find(({ type }) => type === 'patient')?.attributes.ref,
        'Requested by':
          included?.find(({ type, id }) => type === 'staff' && id === unitId)?.attributes.first_name +
          ' ' +
          included?.find(({ type, id }) => type === 'staff' && id === unitId)?.attributes.last_name,
        Unit: included?.find(({ type }) => type === 'unit')?.attributes.name
      }
    }
    return {}
  }, [singleData, included])
  const header = (
    <Box gap={'16px'} margin={{ bottom: '40px', vertical: '16px' }}>
      <Box align="center" direction="row" gap={'8px'}>
        <Text size="24px" weight={600}>
          {included?.find(({ type }) => type === 'bed')?.attributes.bed_type || '---'}
        </Text>
        <Badge
          label={singleData?.attributes.bed_id ? 'Assigned' : 'Pending'}
          status={singleData?.attributes.bed_id ? 'Assigned' : 'Pending'}
        />
      </Box>
      {!included?.find(({ type }) => type === 'bed')?.attributes.bed_type && (
        <div className="max-w-[157px]">
          <Button
            icon={<PencilIcon />}
            kinds={'secondary'}
            label="Assign bed"
            onClick={() => openModal(ADMIN_MODAL_TYPE.ASSIGN_BED_MODAL, { requestId: defaultData?.id })}
            size={'sm'}
          />
        </div>
      )}
    </Box>
  )

  return (
    <SideDrawer header={header} onClose={onClose} style={{ padding: '0 40px' }} title="Details">
      <Box flex pad={{ horizontal: '24px' }} style={{ overflow: 'hidden', position: 'relative' }}>
        {singleReqLoading && (
          <Box align="center" alignSelf="center" direction="row" gap="small" justify="center" pad="large">
            <Spinner height={'40px'} size="5px" width={'40px'} />
            <Text color="white">Loading...</Text>
          </Box>
        )}
        {singleData && <InformationList data={details} title="Details" />}
      </Box>
    </SideDrawer>
  )
}
